import { Cache } from "@siteimprove/alfa-cache";
import { Element, Namespace, Node, Query, } from "@siteimprove/alfa-dom";
import { None, Option } from "@siteimprove/alfa-option";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Style } from "@siteimprove/alfa-style";
import { Question } from "../act/question.js";
const { isElement, hasName, hasNamespace } = Element;
const { and } = Predicate;
const { isVisible } = Style;
const { getElementDescendants } = Query;
const visibleVideos = Cache.empty();
export function video(document, device, options) {
    const { audio, track } = options;
    const videos = visibleVideos
        .get(document, Cache.empty)
        .get(device, () => getElementDescendants(document, Node.fullTree).filter(and(hasNamespace(Namespace.HTML), hasName("video"), isVisible(device))));
    return (track === undefined
        ? videos
        : videos.filter(hasTrack(track.has, track.kind))).map((element) => Question.of("is-video-streaming", element).map((isStreaming) => {
        if (isStreaming) {
            return None;
        }
        return Question.of("has-audio", element).map((hasAudio) => audio.has === hasAudio ? Option.of(element) : None);
    }));
}
function hasTrack(has, kind) {
    return (element) => has ===
        element
            .children()
            .filter(isElement)
            .some(and(hasName("track"), (trackElement) => trackElement
            .attribute("kind")
            // {@link https://html.spec.whatwg.org/multipage/media.html#attr-track-kind}
            .map((kind) => kind
            .enumerate("subtitles", "captions", "descriptions", "chapters", "metadata")
            // invalid value default
            .getOr("metadata"))
            // missing value default
            .getOr("subtitles") === kind));
}
//# sourceMappingURL=video.js.map